import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { OrderGroup } from "../../filter/shared/utils/types";
import { IAppUsersState } from "../shared/interfaces/app-users-state";

import { APP_USERS_MODULE_NAME } from "./constants";

const FIRST_PAGE = 0;
const DEFAULT_PAGE_SIZE = 10;

const initialState: IAppUsersState = {
  searchText: "",
  page: FIRST_PAGE,
  limit: DEFAULT_PAGE_SIZE,
  order: [],
};

export const appUsersSlice = createSlice({
  name: APP_USERS_MODULE_NAME,
  initialState,
  reducers: {
    setSearchText(state, action: PayloadAction<string>): void {
      state.searchText = action.payload;
      state.page = FIRST_PAGE;
    },
    setPage(state, action: PayloadAction<number>): void {
      state.page = action.payload;
    },
    setLimit(state, action: PayloadAction<number>): void {
      state.limit = action.payload;
      state.page = FIRST_PAGE;
    },
    setOrder(state, action: PayloadAction<OrderGroup>): void {
      state.order = action.payload;
    },
  },
});

export const appUsersReducer = appUsersSlice.reducer;
export const { setSearchText, setPage, setLimit, setOrder } = appUsersSlice.actions;
